import { render, staticRenderFns } from "./ChangeNumberLabel.vue?vue&type=template&id=b2133764&"
import script from "./ChangeNumberLabel.vue?vue&type=script&lang=js&"
export * from "./ChangeNumberLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports